import { ChannelType, channelTypeInfo, electricalChannelType } from "./ChannelType";
import Signal from "./Signal";
import { signalBundleDefinitions } from "./SignalBundleDefinitions";
import SignalType from "./SignalType";
import Logger from "../Logger";
import { NameListEntry } from "../KnxMappings/NameEntryList";
import SignalTypes from "./SignalTypes";
//import { allRuleArraysInOne } from "../KnxMappings/DPTSignalTypesList";

const logger = new Logger();

export function getAllSignalBundles(): Map<ChannelType, Array<SignalType>> {
  const res = new Map<ChannelType, Array<SignalType>>();
  for (let i in ChannelType) {
    const tp = ChannelType[i as keyof typeof ChannelType];
    if (tp != ChannelType.Unknown) {
      const b = getSignalTypeBundle(tp);
      res.set(tp, b);
    }
  }
  return res;
}

export function getAllSignalBundlesWithSignalType(filterSignalType: SignalType): Map<ChannelType, Array<SignalType>> {
  const res = new Map<ChannelType, Array<SignalType>>();

  const allBundles = getAllSignalBundles();
  allBundles.forEach((bundle, channelType) => {
    var match = false;
    bundle.forEach((signalType) => {
      if (signalType == filterSignalType) {
        match = true;
      }
    });
    if (match) {
      res.set(channelType, bundle);
    }
  });

  return res;
}

export function getSmallestChannelType(input: Map<ChannelType, Array<SignalType>>): ChannelType {
  var smallestCount = 999;
  var smallestType = ChannelType.Unknown;

  input.forEach((bundle, channelType) => {
    if (bundle.length < smallestCount) {
      smallestCount = bundle.length;
      smallestType = channelType;
    }
  });

  return smallestType;
}

export function belongsToBundle(channelType: ChannelType, signal: Signal): boolean {
  var res = false;

  if (channelType == ChannelType.Generic) {
    return true;
  }

  if (channelType != ChannelType.Unknown) {
    //
    // a SignalBundle defines the maximum set of signals we what to suport for a channel
    //
    const bundle: Array<SignalType> = getSignalTypeBundle(channelType);
    bundle.forEach((signalType) => {
      if (signalType.name == signal.type.name) {
        res = true;
      }
    });
  }

  return res;
}

export function getSignalTypeBundle(channelType: ChannelType): Array<SignalType> {
  return [...getSignalTypeBundleWithoutScene(channelType), SignalTypes.Scene];
}

export function getSignalTypeBundleWithoutScene(channelType: ChannelType): Array<SignalType> {
  channelType = electricalChannelType(channelType);
  var types = Array<SignalType>();

  const bundle = signalBundleDefinitions.get(channelType);
  if (bundle && channelType != ChannelType.Unknown && channelType != ChannelType.Ignored) {
    types = bundle.basicSignals;
  } else {
    if (!channelTypeInfo(channelType).hasNoBundle) {
      logger.error(`SignalBundle not found: ${channelType}`);
    }
  }

  return types;
}

export function getAllSignalBundlesFromType(signalType: SignalType): {
  basic: Array<ChannelType>;
  extendet: Array<ChannelType>;
} {
  const extendet = new Array<ChannelType>();
  const basic = new Array<ChannelType>();
  signalBundleDefinitions.forEach((signalBundeldef, channelType) => {
    if (signalBundeldef.basicSignals.includes(signalType)) {
      basic.push(channelType);
    }
    // if (signalBundeldef.extendedSignals?.includes(signalType)) {
    //   extendet.push(channelType);
    // }
  });
  return { basic: basic, extendet: extendet };
}
